import { useState, useEffect } from 'react';
import axios from 'axios';

/**
 * Site-builder tenant features (frontend).
 * Platform mode (tenant === null) → full access, nothing hidden.
 * Tenant mode → only the plan's feature keys are enabled.
 */
let cachePromise = null;
function loadTenant() {
  if (!cachePromise) {
    cachePromise = axios.get('/site-settings')
      .then(r => (r.data && r.data.tenant) || null)
      .catch(() => null);
  }
  return cachePromise;
}

export function useTenant() {
  const [tenant, setTenant] = useState(undefined); // undefined = loading
  useEffect(() => { loadTenant().then(setTenant); }, []);
  return tenant;
}

/** null while loading; true in platform mode or when the feature is enabled. */
export function useFeature(key) {
  const tenant = useTenant();
  if (tenant === undefined) return null;
  if (tenant === null) return true;
  return (tenant.features || []).includes(key);
}

/** Gate wrapper: renders children only if the feature is on (platform = always). */
export function FeatureGate({ feature, children, fallback = null }) {
  const ok = useFeature(feature);
  if (ok === null) return null;
  return ok ? children : fallback;
}

/** Known module keys for the owner panel (fa labels). */
export const MODULES = [
  { key: 'products', fa: 'محصولات' },
  { key: 'blog', fa: 'وبلاگ' },
  { key: 'discounts', fa: 'تخفیف‌ها' },
  { key: 'referral', fa: 'دعوت دوستان' },
  { key: 'cards', fa: 'کارت‌های بانکی' },
  { key: 'club', fa: 'باشگاه مشتریان' },
  { key: 'wheel', fa: 'گردونه شانس' },
  { key: 'forms', fa: 'فرم‌ساز' },
  { key: 'torob', fa: 'اتصال ترب' },
  { key: 'analytics', fa: 'تحلیل بازدید' },
  { key: 'installments', fa: 'فروش اقساطی' },
  { key: 'priority', fa: 'پشتیبانی ویژه' },
];

// UTM: ذخیره اولین منبع ورودی جلسه (first-touch) برای اتصال سفارش به کمپین
export function captureUtm() {
  try {
    const q = new URLSearchParams(window.location.search || '');
    const cur = {
      utm_source: sessionStorage.getItem('utm_source') || '',
      utm_medium: sessionStorage.getItem('utm_medium') || '',
      utm_campaign: sessionStorage.getItem('utm_campaign') || '',
    };
    let changed = false;
    ['utm_source', 'utm_medium', 'utm_campaign'].forEach(k => {
      const v = (q.get(k) || '').trim().slice(0, 128);
      if (v && !cur[k]) { sessionStorage.setItem(k, v); changed = true; }
    });
    return changed;
  } catch { return false; }
}
export function readUtm() {
  try {
    return {
      utm_source: sessionStorage.getItem('utm_source') || undefined,
      utm_medium: sessionStorage.getItem('utm_medium') || undefined,
      utm_campaign: sessionStorage.getItem('utm_campaign') || undefined,
    };
  } catch { return {}; }
}
